import { useEffect, useRef } from "react";

const BLOCKED_TARGET = "input, textarea, select, [contenteditable]:not([contenteditable='false']), [role='textbox'], [role='dialog'], [role='alertdialog'], .cm-editor, .monaco-editor, .xterm, [data-editor], [data-terminal]";

function blocked(event: KeyboardEvent): boolean {
  if (event.defaultPrevented || event.repeat || event.isComposing || event.keyCode === 229 ||
      event.ctrlKey || event.metaKey || event.altKey || event.shiftKey) return true;
  return event.target instanceof Element && Boolean(event.target.closest(BLOCKED_TARGET));
}

/** 기본 OFF. 별도 timer 없이 다음 key 시각에서 1초 창을 판정합니다. */
export function useNavigationShortcuts(
  enabled: boolean,
  routes: readonly { path: string }[],
  navigate: (path: string) => void,
  resetIdentity: string,
) {
  const armedAt = useRef<number>();
  useEffect(() => {
    armedAt.current = undefined;
    if (!enabled) return undefined;
    const reset = () => { armedAt.current = undefined; };
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") { reset(); return; }
      if (blocked(event) || document.querySelector("dialog[open], [role='dialog'][aria-modal='true'], [role='alertdialog']")) { reset(); return; }
      const now = event.timeStamp;
      if (event.key.toLowerCase() === "g") { armedAt.current = now; return; }
      const armed = armedAt.current;
      reset();
      if (!/^[1-9]$/.test(event.key) || armed === undefined || now - armed > 1_000 || now < armed) return;
      const route = routes[Number(event.key) - 1];
      if (!route) return;
      event.preventDefault();
      navigate(route.path);
    };
    const onVisibility = () => { if (document.hidden) reset(); };
    window.addEventListener("keydown", onKeyDown);
    window.addEventListener("blur", reset);
    document.addEventListener("visibilitychange", onVisibility);
    return () => {
      reset();
      window.removeEventListener("keydown", onKeyDown);
      window.removeEventListener("blur", reset);
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, [enabled, navigate, resetIdentity, routes]);
}
